export const AI_BUILDER_SIGNALS = {
    /** Wizard confirm: the user completed the requested panel action */
    STEP_DONE: '[STEP_DONE]',
    /** Wizard help request on the current configure step */
    NEED_HELP: '[NEED_HELP]',
    /** Escalation after a first help answer */
    NEED_MORE_HELP: '[NEED_MORE_HELP]',
    /** Panel "Need help?" entry: routed to the BUILD agent with debug context */
    HELP_STEP: '[HELP_STEP]',
    /** Card answer: followed by a JSON-serialized CardReply */
    CARD_REPLY: '[CARD_REPLY]',
    /** The page never received the last answer: pick up where the flow stands */
    RESUME: '[RESUME]',
} as const

export type AiBuilderSignal =
    (typeof AI_BUILDER_SIGNALS)[keyof typeof AI_BUILDER_SIGNALS]

/** Boundary tags marking untrusted external data inside prompts */
export const EXTERNAL_DATA_MARKERS = {
    START: '[EXTERNAL_DATA_START]',
    END: '[EXTERNAL_DATA_END]',
} as const

/**
 * inputUiInfo key the PANEL writes when a manual step test fails: the wizard
 * has no other way to know — a failed test persists no sample data, so the
 * server would only see "still untested" and ask for the test again.
 * Carries the formatted MESSAGE only, never the raw output: an HTTP step's
 * output echoes the request headers, credentials included.
 */
export const AI_BUILDER_LAST_TEST_ERROR = 'aiBuilderLastTestError'

/** Panel error messages are truncated before they are persisted or shown */
export const AI_BUILDER_TEST_ERROR_MAX_LENGTH = 500
